import { StatesRegion } from '../interfaces/Location/Location'

export const stateRegion: StatesRegion[] = [
  {
    name: 'Metropolitana de Santiago',
    stateCode: 13
  },
  {
    name: 'Arica y Parinacota',
    stateCode: 15
  },
  {
    name: 'Tarapacá',
    stateCode: 1
  },
  {
    name: 'Antofagasta',
    stateCode: 2
  },
  {
    name: 'Atacama',
    stateCode: 3
  },
  {
    name: 'Coquimbo',
    stateCode: 4
  },
  {
    name: 'Valparaíso',
    stateCode: 5
  },
  {
    name: 'Libertador Gral. Bernardo O’Higgins',
    stateCode: 6
  },
  {
    name: 'Maule',
    stateCode: 7
  },
  {
    name: 'Ñuble',
    stateCode: 16
  },
  {
    name: 'Biobío',
    stateCode: 8
  },
  {
    name: 'Araucanía',
    stateCode: 9
  },
  {
    name: 'Los Ríos',
    stateCode: 14
  },
  {
    name: 'Los Lagos',
    stateCode: 10
  },
  {
    name: 'Aisén del Gral. Carlos Ibáñez del Campo',
    stateCode: 11
  },
  {
    name: 'Magallanes y de la Antártica Chilena',
    stateCode: 12
  }
]
